export const equalizeItems = elements => {
    setTimeout(() => {
        setHeights(elements);

        const height = getTallestHeight(elements);

        setHeights(elements, height);
    }, 100);
};

export const resetItems = (elements, resetHeight) => {
    setTimeout(() => setHeights(elements, resetHeight), 100);
};

const getTallestHeight = elements => {
    let height = null;

    elements.map(element => {
        if (!height || element.offsetHeight > height) {
            height = element.offsetHeight;
        }
    });

    return height;
};

const setHeights = (elements, height) => {
    elements.map(element => element.style.height = height ? `${height}px` : 'auto');
};
